import { Component, OnInit, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  items: any[];
  @Output() sideBarStatus = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  sideBar() {
    this.sideBarStatus.emit(true);
  }
}
